module.exports = __webpack_public_path__ + "static/media/ordericon.e6bda397.svg";